<template>
    <div :class="['popin-view']" aria-hidden="false">
        <div
            class="shadow"
            @click="closePopin()"
        />
        <component
            :is="`block-${data.type}`"
            :data="data"
            @close="closePopin()"
        />
    </div>
</template>

<script>
import BlockTeam from '@/views/PopIn/BlockTeam'
import BlockMethod from '@/views/PopIn/BlockMethod'
import BlockStory from '@/views/PopIn/BlockStory'
import {popin} from '@/store/index.js'
export default {
    // name: 'page',
    components: {
        BlockTeam,
        BlockMethod,
        BlockStory
    },
    // mixins: [PageView],
    props: {
        data: {
            type: Object,
            default() {return {}}
        }
    },
    // watch: {
    //     '$route.params.locale'() {
    //         this.requestData()
    //     }
    // },
    mounted() {
        document.body.classList.add("background")
    },
    beforeDestroy() {
        document.body.classList.remove("background")
    },
    methods: {
        closePopin() {
            popin.state = false
            popin.data = {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.popin-view
    position: fixed
    height: 100%
    width: 100%
    top: 0
    left: 0
    display: flex
    justify-content: center
    align-items: center
    z-index: 50
.shadow
    position: absolute
    background-color: rgba(#646873, 0.7)
    height: 100%
    width: 100%
    top: 0
    left: 0
.popin-content
    position: relative
    z-index: 1
</style>
